import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

export const SessionTimeoutAlert: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<'warning' | 'error'>('warning');

  useEffect(() => {
    const handleWarning = (event: Event) => {
      const customEvent = event as CustomEvent;
      setMessage(customEvent.detail.message);
      setSeverity('warning');
      setOpen(true);
    };

    const handleExpired = (event: Event) => {
      const customEvent = event as CustomEvent;
      setMessage(customEvent.detail.message);
      setSeverity('error');
      setOpen(true);
    };

    window.addEventListener('session-warning', handleWarning);
    window.addEventListener('session-expired', handleExpired);

    return () => {
      window.removeEventListener('session-warning', handleWarning);
      window.removeEventListener('session-expired', handleExpired);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={severity === 'warning' ? 10000 : null}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}; 